// controllers/searchableSelectController.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "dropdown", "selectedText", "hiddenInput", "chevron", "searchInput", "option", "optionsContainer"]
  static values = { name: String }

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.boundHandleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside)
  }

  toggle(event) {
    event.stopPropagation()

    // Close all other dropdowns first
    this.closeOtherDropdowns()

    // Toggle this dropdown
    const isHidden = this.dropdownTarget.classList.toggle("hidden")
    this.chevronTarget.classList.toggle("rotate-180")

    // If opening, focus search input and reset search
    if (!isHidden) {
      this.searchInputTarget.value = ""
      this.search()
      setTimeout(() => this.searchInputTarget.focus(), 100)
    }
  }

  search() {
    const searchTerm = this.searchInputTarget.value.toLowerCase()
    let visibleCount = 0

    this.optionTargets.forEach(option => {
      const text = option.textContent.toLowerCase()
      if (text.includes(searchTerm)) {
        option.classList.remove("hidden")
        visibleCount++
      } else {
        option.classList.add("hidden")
      }
    })

    // Show "No results" message if no options match
    this.updateNoResultsMessage(visibleCount)
  }

  updateNoResultsMessage(visibleCount) {
    let noResultsEl = this.optionsContainerTarget.querySelector('[data-no-results]')

    if (visibleCount === 0) {
      if (!noResultsEl) {
        noResultsEl = document.createElement('div')
        noResultsEl.setAttribute('data-no-results', '')
        noResultsEl.className = 'px-4 py-8 text-center text-gray-500'
        noResultsEl.textContent = 'No items found'
        this.optionsContainerTarget.appendChild(noResultsEl)
      }
    } else if (noResultsEl) {
        noResultsEl.remove()
    }
  }

  select(event) {
    const displayText = event.params.display
    const value = event.params.value

    this.selectedTextTarget.textContent = displayText
    this.selectedTextTarget.classList.remove(
      "dark:text-dark-input-icon-and-text-secondary",
      "wdark:text-wdark-input-icon-and-text-secondary"
    )
    this.selectedTextTarget.classList.add(
      "dark:text-dark-input-icon-and-text",
      "wdark:text-wdark-input-icon-and-text"
    )

    this.hiddenInputTarget.value = value
    this.hiddenInputTarget.name = this.nameValue

    this.close()

    this.hiddenInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  close() {
    this.dropdownTarget.classList.add("hidden")
    this.chevronTarget.classList.remove("rotate-180")
    this.searchInputTarget.value = ""
    this.search() // Reset all options to visible
  }

  closeOtherDropdowns() {
    // Find all other searchable-select controllers and close their dropdowns
    document.querySelectorAll('[data-controller*="searchable-select"]').forEach(element => {
      if (element !== this.element) {
        const controller = this.application.getControllerForElementAndIdentifier(element, "searchable-select")
        if (controller && controller.close) {
          controller.close()
        }
      }
    })

    // Also close regular select dropdowns (substring match can hit non-select controllers; getController may be null)
    document.querySelectorAll('[data-controller*="select"]').forEach(element => {
      if (element !== this.element) {
        const controller = this.application.getControllerForElementAndIdentifier(element, "select")
        if (controller && controller.close) {
          controller.close()
        }
      }
    })
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}

